// extracted by mini-css-extract-plugin
export var copyIcon = "_s0-2";
export var discountCard = "_s0-0";
export var discountCode = "_s0-3";
export var discountContent = "_s0-1";
export var loadingCard = "_s0-4";